import { RetryActionJobStatus } from 'src/constants/scheduler/enums'
import type { RetryActionJob } from 'src/interfaces/retryConfig'

/**
 * Whether a retry job may be rescheduled.
 *
 * Gated on STATUS, not on `processedAt`. The Retool prototype tests
 * `Boolean(currentRow.processedAt)`, but `AdminRetryManagementService.rescheduleOne` throws
 * `Only scheduled jobs can be rescheduled` — and a `processing` job has no `processedAt` yet,
 * so the prototype's test offers a control that fails server-side.
 */
export const canRescheduleJob = (job: RetryActionJob): boolean => {
  return job.status === RetryActionJobStatus.Scheduled
}
